<div class="btn-group btn-toggle">
  <button
    class="btn btn-lg"
    (click)="emitChange()"
    [ngClass]="{
      'btn-success active': value,
      'btn-default': !value
    }"
  >
    ON
  </button>
  <button
    class="btn btn-lg"
    (click)="emitChange()"
    [ngClass]="{
      'btn-danger active': !value,
      'btn-default': value
    }"
  >
    OFF
  </button>
</div>
